<template>
  <div 
    v-bind="$attrs" 
    class="content content-richtext" 
    v-html="processedValue"
  >
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    replacements: {
      type: Array
    }
  },
  computed: {
    processedValue({ value, replacements }) {
      if (replacements) {
        let copiedValue = `${value}`;
        replacements.forEach(replacement => {
          copiedValue = copiedValue.replace(...replacement)
            .replace('<li><li>', '<li>')
            .replace('</li></li>', '</li>')
        })
        return copiedValue
      } else {
        return value
      }
    }
  }
}
</script>